import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { Table } from "../../../../component/table/Table";
import { CategoryPageSkeleton } from "../../../../component/skeleton/CategoryPageSkeleton";

import {
  selectBulkSparesLotFilterState,
  setBulkSparesLotFilter,
} from "../../../../store/bulk/bulkSparesLotFilterSlice";

import { bulkSpareLotListTableColumnsConfig } from "./bulkSpareLotListTableColumnDef";
import { selectBulkSpareLotItems, useGetBulkSpareLotListQuery } from "../../../../services/bulk/spares/bulkSpareLotListApiSlice";

export const BulkSpareLotListTablePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { request_id } = useParams();

  // const {
  //   request_id: storedRequestId,
  //   seller_id,
  //   status,
  // } = useSelector(selectBulkSparesLotFilterState);

  

const { request_id } = useParams();

const { seller_id, status } = useSelector(
  selectBulkSparesLotFilterState
);
console.log("id", request_id);

const { isLoading, isFetching, isError, isSuccess } =
  useGetBulkSpareLotListQuery(
    {
      request_id,
      seller_id,
      status,
    },
    { skip: !request_id }
  );

  useEffect(() => {
    if (request_id) {
      dispatch(setBulkSparesLotFilter({ request_id }));
    }
  }, [request_id, dispatch]);

  /* ✅ Get normalized data from entity adapter */
  const bulkSpareLotList = useSelector(selectBulkSpareLotItems);

  console.log("request", bulkSpareLotList);

  const handleNavigate = useCallback(
    (lotId) => {
      navigate(`/bulk_deals/spares/${request_id}/items/${lotId}`);
    },
    [navigate, request_id],
  );

  const handleDownload = useCallback(() => {
    // handle download logic here
  }, []);

  const columnDefs = useMemo(
    () => bulkSpareLotListTableColumnsConfig(handleDownload, handleNavigate),
    [handleDownload, handleNavigate],
  );

  if (isError) return <div>Something went wrong</div>;

  return isSuccess ? (
    <Table
      data={bulkSpareLotList}
      columns={columnDefs}
      loading={isLoading}
      isfetching={isFetching}
    />
  ) : (
    <CategoryPageSkeleton />
  );
};
